<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{
          isEdit ? "Editar Asignacion de Liquidacion" : "Registrar Liquidacion"
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <!-- Campos principales del formulario de liquidación -->
          <v-row class="py-md-1 my-md-n6">
            <v-col cols="12">
              <v-subheader>Motivo de Viaje</v-subheader>
              <v-textarea
                v-model="localItem.motivoViaje"
                rows="2"
                solo
                readonly
                required
              />
            </v-col>
          </v-row>
          <v-row class="py-md-0 my-md-n7">
            <v-col cols="12" sm="3" md="3">
              <v-subheader>Lugar de Comision</v-subheader>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="localItem.paisComision"
                :items="paises"
                :rules="[(v) => !!v || 'Pais es Requerido']"
                solo
                readonly
                required
              />
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                v-model="localItem.iddeptoComision"
                solo
                readonly
                required
              />
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                v-model="localItem.lugarli"
                solo
                readonly
                required
              />
            </v-col>
          </v-row>

          <!-- ...otros campos relevantes de liquidación... -->
          <slot name="extra-fields" :local-item="localItem" />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="onCancel">Cancelar</v-btn>
        <v-btn :disabled="!valid" color="blue darken-1" text @click="onSave"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
export default {
  name: "LiquidacionForm",
  props: {
    value: { type: Object, required: true },
    paises: { type: Array, required: true },
    isEdit: { type: Boolean, default: false },
  },
  data() {
    return {
      localItem: { ...this.value },
      valid: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.localItem = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.$emit("save", { ...this.localItem });
      }
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
